import { Link, Stack } from "flicket-ui";
import useSWR from "swr";
import { useOrganization, useShopifySDK } from "~hooks";
import { renderPriceRange } from "~lib/shopify/utils";
import { ProductCard } from "./productCard";

export const MerchandiseProductCarousel = () => {
  const sdk = useShopifySDK();
  const { organization } = useOrganization();
  const { data } = useSWR("merchandise_carousel", async () =>
    sdk.products({ first: 4 })
  );
  const hasProducts = !!data?.products?.edges?.length;
  return hasProducts ? (
    <Stack
      space={3}
      width="100%"
      css={{ "& > *": { flex: "0 1 25%" } }}
      flexDir={["column", "column", "column", "row"]}
    >
      {data?.products?.edges?.map(({ node }) => (
        <Link
          key={node.id}
          to="/merchandise/[handle]"
          linkAs={`/merchandise/${node.handle}`}
          css={{ "& > *": { height: "100% " } }}
        >
          <ProductCard
            {...node}
            inStock={node.availableForSale}
            price={renderPriceRange(node.priceRange, organization.currency)}
            imgSrc={node.images?.edges?.[0]?.node?.url}
          />
        </Link>
      ))}
    </Stack>
  ) : null;
};
